<template>
    <div>
        <sevenDayNotif :data="assignData" @close="$emit('close')"></sevenDayNotif>
    </div>
</template>

<script>
import sevenDayNotif from './component/sevenDayNotif.vue';
export default {
    name: 'PadmaErpAssignNotification',
    props : ['data'],
    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },

    computed : {
        assignData(){
            let employeeId = this.loggedInUser.employee_id
            return this.data.filter(item => {
                return item.assign === employeeId;
            });
        }
    },

    components : {
        sevenDayNotif
    }
};
</script>

<style lang="scss" scoped>

</style>